webpackJsonp([11],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__(103);
function injectStyle (ssrContext) {
  __webpack_require__(98)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1000:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1001:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"BrandThemeLoading"},[_c('div',{staticClass:"sk-circle"},[_c('div',{staticClass:"sk-circle1 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle2 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle3 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle4 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle5 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle6 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle7 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle8 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle9 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle10 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle11 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle12 sk-child"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1002:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dc868dc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1004);
function injectStyle (ssrContext) {
  __webpack_require__(1003)
}
var normalizeComponent = __webpack_require__(20)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8dc868dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dc868dc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CookiesPolicy animated fadeInUp"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"btn btn-xs button CookiesPolicy__button",attrs:{"id":"js-test__acceptance-button"},on:{"click":function($event){return _vm.$emit('clickAcceptance')}}},[_vm._v("Zgadzam się!")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"CookiesPolicy__policy-text"},[_vm._v("\n        Na naszej stronie korzystamy z plików cookies, dlatego do korzystania z serwisu lajt-online.pl konieczne jest potwierdzenie wymaganych zgód. Wszystkie\n        zasady ich użytkowania wraz z informacjami o sposobie wyrażania i cofania zgody na używanie plików cookies, opisaliśmy w "),_c('a',{staticClass:"policy-text__more",attrs:{"id":"js-test__service-terms-link","href":"https://lajtmobile.pl/wp-content/uploads/2020/12/Polityka-Prywatnosci-i-Cookie-obowiazuje-od-25.05.2018.pdf","target":"_blank"}},[_vm._v("Polityce\n            Prywatności i Cookie")]),_vm._v(". Korzystając z serwisu akceptujesz jej postanowienia oraz "),_c('a',{staticClass:"policy-text__more",attrs:{"id":"js-test__service-terms-link","href":"https://lajtmobile.pl/wp-content/uploads/2020/12/Regulamin-Serwisu-Internetowego-lajt-mobile-Panelu-Klienta-obowiazuje-od-25.05.2018.pdf","target":"_blank"}},[_vm._v("Regulamin Serwisus\n        ")]),_vm._v(".\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"app"}},[(_vm.pendingStoreActions.includes('getBrandTheme'))?_c('BrandThemeLoading'):_vm._e(),_vm._v(" "),(!_vm.pendingStoreActions.includes('getBrandTheme'))?_c('router-view',{class:{ 'is-offline': _vm.isOffline }}):_vm._e(),_vm._v(" "),_c('OfflineIndicator'),_vm._v(" "),(_vm.shouldShowCookiePolicy)?_c('CookiesPolicy',{on:{"clickAcceptance":_vm.acceptCookiePolicy}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1006:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filters__ = __webpack_require__(1007);

/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-23, 15:45:35
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */




__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_2__filters__).forEach(function (filter) {
  return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].filter(filter, __WEBPACK_IMPORTED_MODULE_2__filters__[filter]);
});

/***/ }),

/***/ 1007:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HHMMSS", function() { return HHMMSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayNumber", function() { return displayNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkIfFree", function() { return checkIfFree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayValue", function() { return displayValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatDataAccordingToAccountType", function() { return formatDataAccordingToAccountType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatToAccountNumber", function() { return formatToAccountNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "returnOnlyIfValueIncludesInArray", function() { return returnOnlyIfValueIncludesInArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "returnOnlyIfConditionIncludesInVal", function() { return returnOnlyIfConditionIncludesInVal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(17);

/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-03-23, 15:41:17
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-05, 16:06:22
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */



// change seconds do HHMMSS format
var HHMMSS = function HHMMSS(totalSeconds) {
  var _totalSeconds = parseInt(totalSeconds, 0);
  if (_totalSeconds === 0 || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(_totalSeconds)) return '---';
  var hours = Math.floor(_totalSeconds / 3600);
  if (hours < 10) hours = '0' + hours;
  _totalSeconds %= 3600;
  var minutes = Math.floor(_totalSeconds / 60);
  if (minutes < 10) minutes = '0' + minutes;
  var seconds = _totalSeconds % 60;
  if (seconds < 10) seconds = '0' + seconds;
  return hours + ':' + minutes + ':' + seconds;
};

// display number nine digit number, if there is no number, display '---'
var displayNumber = function displayNumber(number) {
  var _number = String(number).replace(/ /g, '');
  if (_number.match(/^\+?[0-9#*]+$/) !== null && _number.replace(/0/g, '').length) {
    return _number.length === 9 && !isNaN(Number(_number)) ? _number.slice(0, 3) + ' ' + _number.slice(3, 6) + ' ' + _number.slice(6, 9) : '' + _number;
  }return '---';
};

// check if value exists, if there is not - display word "Bezpłatne"
var checkIfFree = function checkIfFree(value) {
  return value > 0 ? value : 'Bezpłatne';
};

// display value with two digits after comma
var displayValue = function displayValue(value) {
  return parseFloat(value).toFixed(2).replace('.', ',');
};

// change bytes or kilobytes to KB, MB etc.
// source: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
var formatDataAccordingToAccountType = function formatDataAccordingToAccountType(bytes) {
  var _bytes = Number(bytes);
  if (_bytes === 0) return '---';
  var k = 1024;
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var shiftSizes = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.subscriber.type === 'postpaid' ? 1 : 0;
  var i = Math.floor(Math.log(_bytes) / Math.log(k));
  return parseFloat((_bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i + shiftSizes];
};

// format account number from string to properly IBAN number
var formatToAccountNumber = function formatToAccountNumber(number) {
  return ('PL' + number).replace(/(.{4})(?!$)/g, '$1 ');
};

// Should return exactly the same value as the passed argument only if value in property "val" is included in array
var returnOnlyIfValueIncludesInArray = function returnOnlyIfValueIncludesInArray(value) {
  var conditionObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { val: null, condition: [] };
  return conditionObject.condition.includes(conditionObject.val) ? value : null;
};

var returnOnlyIfConditionIncludesInVal = function returnOnlyIfConditionIncludesInVal(value) {
  var conditionObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { val: null, condition: '' };
  return conditionObject.val.includes(conditionObject.condition) ? value : null;
};

/***/ }),

/***/ 1008:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('click-outside', {
  bind: function bind(el, binding, vnode) {
    // eslint-disable-next-line no-param-reassign
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.value.method](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  update: function update(el, binding) {
    if (binding.value.loading) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
    } else {
      document.body.addEventListener('click', el.clickOutsideEvent);
    }
  },
  unbind: function unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Inter.3220473.ttf";

/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-BlackItalic.e9c5c58.ttf";

/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-Black.14d00da.ttf";

/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-BoldItalic.19406f7.ttf";

/***/ }),

/***/ 1021:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-Bold.08c20a4.ttf";

/***/ }),

/***/ 1022:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-ExtraBoldItalic.8afe4dc.ttf";

/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-ExtraBold.d45bdbc.ttf";

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-ExtraLightItalic.a9bed01.ttf";

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-ExtraLight.6f8391b.ttf";

/***/ }),

/***/ 1026:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-Italic.c103423.ttf";

/***/ }),

/***/ 1027:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-LightItalic.0613c48.ttf";

/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-Light.fcc40ae.ttf";

/***/ }),

/***/ 1029:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-MediumItalic.cf5ba39.ttf";

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",function(){return [(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-Medium.bf59c68.ttf";

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-Regular.093ee89.ttf";

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-SemiBoldItalic.9841f3d.ttf";

/***/ }),

/***/ 1033:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-SemiBold.6f1520d.ttf";

/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-ThinItalic.01555d2.ttf";

/***/ }),

/***/ 1035:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/Poppins-Thin.9ec2636.ttf";

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return togglePendingStoreActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleErrorResponses; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_sErrorHandler__ = __webpack_require__(70);



/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-21, 09:51:17
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 11:57:54
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */




/**
 * Dekorator dla akcji w Vuex, który pozwala na informowanie o akcja, które aktualnie
 * trwają
 */
var togglePendingStoreActions = function togglePendingStoreActions() {
  return function (target, key, descriptor) {
    var _descriptor = descriptor;
    var orginalMethod = _descriptor.value;
    _descriptor.value = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var storeActionsName;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                storeActionsName = key;

                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('TOGGLE_PENDING_STORE_ACTIONS', storeActionsName);
                _context.next = 4;
                return orginalMethod.apply(this, args);

              case 4:
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('TOGGLE_PENDING_STORE_ACTIONS', storeActionsName);
                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve());

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }();
    return descriptor;
  };
};

var handleErrorResponses = function handleErrorResponses() {
  return function (target, key, descriptor) {
    var _descriptor = descriptor;
    var orginalMethod = descriptor.value;
    _descriptor.value = function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _len2,
            args,
            _key2,
            status,
            errors,
            errorMessage,
            _args2 = arguments;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                for (_len2 = _args2.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  args[_key2] = _args2[_key2];
                }

                _context2.next = 4;
                return orginalMethod.apply(this, args);

              case 4:
                _context2.next = 11;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](0);
                status = _context2.t0.response.status;
                errors = _context2.t0.response.data.data;

                if (status === 406) {
                  errorMessage = __WEBPACK_IMPORTED_MODULE_5__services_sErrorHandler__["a" /* default */].createErrorMessage(errors);

                  new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]().$toaster.error(errorMessage);
                }

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 6]]);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }();
    return descriptor;
  };
};

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_Subscriber__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Recharges__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Billing__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_Brand__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_Help__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_App__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_PaymentsAndInvoices__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_Complains__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_Services__ = __webpack_require__(989);
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-02, 14:57:46
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-01, 11:26:41
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */




// MODULES /////////////////////////////////////////////////////////////////////










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    Subscriber: __WEBPACK_IMPORTED_MODULE_2__modules_Subscriber__["a" /* default */],
    App: __WEBPACK_IMPORTED_MODULE_7__modules_App__["a" /* default */],
    Recharges: __WEBPACK_IMPORTED_MODULE_3__modules_Recharges__["a" /* default */],
    Billing: __WEBPACK_IMPORTED_MODULE_4__modules_Billing__["a" /* default */],
    Brand: __WEBPACK_IMPORTED_MODULE_5__modules_Brand__["a" /* default */],
    Help: __WEBPACK_IMPORTED_MODULE_6__modules_Help__["a" /* default */],
    Payments: __WEBPACK_IMPORTED_MODULE_8__modules_PaymentsAndInvoices__["a" /* default */],
    Complains: __WEBPACK_IMPORTED_MODULE_9__modules_Complains__["a" /* default */],
    Services: __WEBPACK_IMPORTED_MODULE_10__modules_Services__["a" /* default */]
  },
  strict: !Object({"NODE_ENV":"production","SENTRY":true,"API_URL":"//lajt-online.pl/api","APP_VERSION":"production - Mon Nov  2 13:25:33 UTC 2026"}).DEBUG_MODE
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(7);
/**
* description:
* File of sAuth Service
*
* Serwis jest odpowiedzialny za obsługe autoryzację JWT
* Metody serwisu wzorowane na bibliotece angular-jwt:
* source: https://github.com/auth0/angular-jwt/blob/master/src/angularJwt/services/jwt.js
*
* data : 2017-02-12
*/



var sAuth = function () {
  return {
    setToken: setToken,
    decodeToken: decodeToken,
    getTokenExpirationDate: getTokenExpirationDate,
    checkTokenExpirationDate: checkTokenExpirationDate,
    verifyToken: verifyToken,
    removeToken: removeToken
  };

  // /// PRIVATE ////////////////////////////////////////////////////////////////
  function __urlBase64Decode(str) {
    var output = str.replace(/-/g, '+').replace(/_/g, '/');
    switch (output.length % 4) {
      case 0:
        {
          break;
        }
      case 2:
        {
          output += '==';break;
        }
      case 3:
        {
          output += '=';break;
        }
      default:
        {
          return null;
        }
    }

    return window.decodeURIComponent(escape(window.atob(output)));
  }

  // /// PUBLIC /////////////////////////////////////////////////////////////////

  function setToken(token) {
    __WEBPACK_IMPORTED_MODULE_0__config__["c" /* tokenStorage */].setItem('token', token);
  }

  function removeToken() {
    __WEBPACK_IMPORTED_MODULE_0__config__["c" /* tokenStorage */].removeItem('token');
  }

  function decodeToken(token) {
    var parts = token.split('.');

    if (parts.length !== 3) {
      throw new Error('JWT must have 3 parts');
    }

    var decoded = __urlBase64Decode(parts[1]);
    if (!decoded) {
      throw new Error('Cannot decode the token');
    }

    return JSON.parse(decoded);
  }

  function getTokenExpirationDate(token) {
    var decoded = decodeToken(token);

    if (typeof decoded.exp === 'undefined') {
      return null;
    }

    var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
    d.setUTCSeconds(decoded.exp);

    return d;
  }

  function checkTokenExpirationDate(token) {
    var d = getTokenExpirationDate(token);
    var offsetSeconds = offsetSeconds || 0;
    if (d === null) {
      return false;
    }

    // Token expired?
    return !(d.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
  }

  function verifyToken() {
    var token = __WEBPACK_IMPORTED_MODULE_0__config__["c" /* tokenStorage */].getItem('token');
    return token !== null && !checkTokenExpirationDate(token);
  }
}();

/* harmony default export */ __webpack_exports__["a"] = (sAuth);

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hToggleArrayItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hCreateNewStyleElementInDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hCompareTwoArraysAndReturnDifference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hMapCollectionByCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hDeepCopy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);


/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-21, 09:51:22
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-21, 10:22:04
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
/* eslint-disable */


/**
 * Usuwa (jeżeli jest) lub dodaje (jeżeli nie ma) element do tablicy.
 * Wykorzystuje funkcje _.xor() z biblioteki lodash
 * @param {Array} array
 * @param {any} item
 * @returns {Array} newArray
 */
var hToggleArrayItem = function hToggleArrayItem(array, item) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["xor"])(array, [item]);
};

var hCreateNewStyleElementInDOM = function hCreateNewStyleElementInDOM(cssContent) {
  var newStyleElement = document.createElement('style');
  newStyleElement.innerHTML = cssContent;
  document.body.appendChild(newStyleElement);
};

var hCompareTwoArraysAndReturnDifference = function hCompareTwoArraysAndReturnDifference(arrFirst, arrSecond) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_lodash__["difference"])(arrFirst, arrSecond);
};

var hMapCollectionByCondition = function hMapCollectionByCondition(collection, key) {
  var condition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!(key in collection[0])) return [];

  return collection.filter(function (item) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(condition).every(function (_key) {
      return item[_key] === condition[_key];
    });
  }, condition).map(function (item) {
    return item[key];
  });
};

/**
 * name: hDeepCopy
 *
 * creates deep copy of object (HACK)
 *
 * @param {Object} object
 * @return {Object}
 */
var hDeepCopy = function hDeepCopy(object) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(object));
};

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tokenStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_sAuth__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 10:04:01
 * Author: Sebastian Drzewicki <sebastian.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-05, 10:56:11
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */


// /// AXIOS CONFIG /////////////////////////////////////////////////////////////


var authInterceptor = function authInterceptor(config) {
  // eslint-disable-next-line no-use-before-define
  var jwtToken = tokenStorage.getItem('token');
  var _config = config;
  if (jwtToken) _config.headers.Authorization = 'Bearer ' + jwtToken;
  return _config;
};

var errorHandlerInterceptor = function errorHandlerInterceptor(error) {
  var errorStatusMap = {
    404: 'Błąd',
    429: 'Za dużo prób. Prosimy spróbować ponownie za chwilę',
    503: 'Błąd serwera. Prosimy spróbować ponownie',
    504: 'Chwilowo nasze zasoby nie odpowiadają. Prosimy spróbować ponownie za chwilę',
    500: 'Chwilowy błąd serwera. Prosimy spróbować ponownie'
  };

  // nie pokazuj notyfikacji dla odpowiedzi z HTTP ze statusem 406
  if (error.response ? error.response.status !== 406 && error.response.status !== 403 : true) {
    var timeoutMessage = 'Przekroczono czas oczekiwania, proszę spróbować jeszcze raz';
    new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]().$toaster.error(error.response ? errorStatusMap[error.response.status] : timeoutMessage);
  } else if (error.response && error.response.status === 403) {
    __WEBPACK_IMPORTED_MODULE_2__services_sAuth__["a" /* default */].removeToken();
    window.location.reload();
    new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]().$toaster.error('Ze względów bezpieczeństwa, po 60 minutach nastąpiło automatyczne wylogowanie.');
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
};
/* eslint-disable */
var api = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Brand': window.location.host
  },
  timeout: 20000,
  withCredentials: true
});

api.interceptors.request.use(authInterceptor, errorHandlerInterceptor);
api.interceptors.response.use(function (config) {
  return config;
}, errorHandlerInterceptor);

// /// EXPORTS CONFIG ///////////////////////////////////////////////////////////
var API_URL = "//lajt-online.pl/api";
var tokenStorage = localStorage;
var API = api;

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utils_errorMessages__ = __webpack_require__(956);

/**
* description:
* File of sErrorHandler Serivce
*
* Serwis jest odpowiedzialny za obsługę błędów otrzymanych z API.
*
* data : 2017-08-15
*/



var sErrorHandler = function () {
  return {
    createErrorMessage: createErrorMessage
  };
  // /// PRIVATE ////////////////////////////////////////////////////////////////
  function __getFirstErrorType(errors) {
    var type = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(errors)[0];
    var error = errors[type][0];

    return type + '|' + error;
  }

  // /// PUBLIC /////////////////////////////////////////////////////////////////
  function createErrorMessage(errors) {
    return __WEBPACK_IMPORTED_MODULE_1__services_utils_errorMessages__["a" /* default */][__getFirstErrorType(errors)] || 'Wystąpił nieoczekiwany błąd';
  }
}();

/* harmony default export */ __webpack_exports__["a"] = (sErrorHandler);

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_SMS_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UNDO_LOGIN_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TOGGLE_LOGIN_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SUBSCRIBER_MAIN_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_SUBSCRIBER_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIRM_CHANGE_PASSWORD; });
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-23, 14:43:53
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */

var LOGIN_REQUEST = 'LOGIN_REQUEST';
var SET_SMS_CODE = 'SUBMIT_SMS_CODE';
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
var LOGIN_FAIL = 'LOGIN_FAIL';
var UNDO_LOGIN_STATE = 'UNDO_LOGIN_STATE';
var TOGGLE_LOGIN_LOADING = 'TOGGLE_LOGIN_LOADING';
var SET_SUBSCRIBER_MAIN_DATA = 'SET_SUBSCRIBER_MAIN_DATA';
var SET_SUBSCRIBER_SETTINGS = 'SET_SUBSCRIBER_SETTINGS';
var SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS = 'SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS';
var CONFIRM_CHANGE_PASSWORD = 'CONFIRM_CHANGE_PASSWORD';

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE_RECHARGES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_RECHARGES_TERMS; });
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 15:00:04
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

var COMPLETE_RECHARGES_LIST = 'COMPLETE_RECHARGES_LIST';
var SET_RECHARGES_TERMS = 'SET_RECHARGES_TERMS';

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPLETE_BILLING_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_BILLING_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_BILLING_TERMS; });
/**
* description:
* Mutation types for Billing Vuex Module
*
* data : 2017-08-23
*/

var COMPLETE_BILLING_LIST = 'COMPLETE_BILLING_LIST';
var CLEAR_BILLING_LIST = 'CLEAR_BILLING_LIST';
var SET_BILLING_TERMS = 'SET_BILLING_TERMS';

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILL_BRAND_THEME; });
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-21, 09:54:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 14:11:51
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
var FILL_BRAND_THEME = 'FILL_BRAND_THEME';

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILL_FAQ_LIST; });
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-26, 10:33:12
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:35:01
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

var FILL_FAQ_LIST = 'FILL_FAQ_LIST';

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TOGGLE_OFFLINE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOGGLE_PENDING_STORE_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOGGLE_MOBILE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILL_BANNERS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILL_PANEL_FOOTER_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FILL_RODO_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FILL_OCCASION_ZONE_TILES_CONTENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILL_OCCASION_ZONE_FORM_SETTINGS; });
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:03:58
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */
var TOGGLE_OFFLINE_STATUS = 'TOGGLE_OFFLINE_STATUS';
var TOGGLE_PENDING_STORE_ACTIONS = 'TOGGLE_PENDING_STORE_ACTIONS';
var TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';
var FILL_BANNERS_LIST = 'FILL_BANNERS_LIST';
var FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY = 'FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY';
var FILL_PANEL_FOOTER_ICONS = 'FILL_PANEL_FOOTER_ICONS';
var FILL_RODO_TERMS = 'FILL_RODO_TERMS';
var FILL_OCCASION_ZONE_TILES_CONTENTS = 'FILL_OCCASION_ZONE_TILES_CONTENTS';
var FILL_OCCASION_ZONE_FORM_SETTINGS = 'FILL_OCCASION_ZONE_FORM_SETTINGS';

/***/ }),

/***/ 78:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FILL_PAYMENTS_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FILL_INVOICES_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILL_CORRECTION_INVOICES_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PAYMENTS_ERROR; });
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:11:33
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-01, 11:52:28
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

var FILL_PAYMENTS_DATA = 'FILL_PAYMENTS_DATA';
var FILL_INVOICES_DATA = 'FILL_INVOICES_DATA';
var FILL_CORRECTION_INVOICES_DATA = 'FILL_CORRECTION_INVOICES_DATA';
var SET_PAYMENTS_ERROR = 'SET_PAYMENTS_ERROR';

/***/ }),

/***/ 79:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOGGLE_FORM_SENDING_STATUS; });
/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-10, 12:18:00
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-10, 12:21:55
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

var TOGGLE_FORM_SENDING_STATUS = 'TOGGLE_FORM_SENDING_STATUS';

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMPLETE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMPLETE_CATEGORIES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPLETE_BANNERS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TOGGLE_SERVICE_STATUS_CHANGE_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_SERVICE_STATUS_CONFIRMATION_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_SERVICE_STATUS_CHANGE_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_RESPONSE_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_RESPONSE_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return TOOGLE_SERVICES_LIST_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TOOGLE_CHANGE_STATUS_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TOOGLE_GET_USAGE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMPLETE_PACKAGE_USAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_SELECTED_CATEGORY; });
/**
* description:
* Mutation types for Services Vuex Module
*
* data : 2017-08-23
*/

var COMPLETE_LIST = 'COMPLETE_LIST';
var COMPLETE_CATEGORIES_LIST = 'COMPLETE_CATEGORIES_LIST';
var COMPLETE_BANNERS_LIST = 'COMPLETE_BANNERS_LIST';
var TOGGLE_SERVICE_STATUS_CHANGE_RESULT = 'TOGGLE_SERVICE_STATUS_CHANGE_RESULT';
var SET_SERVICE_STATUS_CONFIRMATION_REQUIRED = 'SET_SERVICE_STATUS_CONFIRMATION_REQUIRED';
var CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED = 'CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED';
var CLEAR_SERVICE_STATUS_CHANGE_RESULT = 'CLEAR_SERVICE_STATUS_CHANGE_RESULT';
var SET_RESPONSE_CODE = 'SET_RESPONSE_CODE';
var CLEAR_RESPONSE_CODE = 'CLEAR_RESPONSE_CODE';
var TOOGLE_SERVICES_LIST_LOADING = 'TOOGLE_SERVICES_LIST_LOADING';
var TOOGLE_CHANGE_STATUS_LOADING = 'TOOGLE_CHANGE_STATUS_LOADING';
var TOOGLE_GET_USAGE_LOADING = 'TOOGLE_GET_USAGE_LOADING';
var COMPLETE_PACKAGE_USAGE = 'COMPLETE_PACKAGE_USAGE';
var SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Common_OfflineIndicator__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Common_BrandThemeLoading__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Common_CookiesPolicy__ = __webpack_require__(1002);



//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  components: { OfflineIndicator: __WEBPACK_IMPORTED_MODULE_6__components_Common_OfflineIndicator__["a" /* default */], BrandThemeLoading: __WEBPACK_IMPORTED_MODULE_7__components_Common_BrandThemeLoading__["a" /* default */], CookiesPolicy: __WEBPACK_IMPORTED_MODULE_8__components_Common_CookiesPolicy__["a" /* default */] },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.shouldShowCookiePolicy = !localStorage.getItem('cookiesPolicyHasBeenAccepted');
              _context.next = 3;
              return _this.getBrandTheme();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      shouldShowCookiePolicy: false
    };
  },

  watch: {
    brandTheme: function brandTheme(_brandTheme) {
      if (_brandTheme) {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_helpers__["b" /* hCreateNewStyleElementInDOM */])(_brandTheme);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['isOffline', 'pendingStoreActions', 'brandTheme'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['getBrandTheme']), {
    acceptCookiePolicy: function acceptCookiePolicy() {
      this.shouldShowCookiePolicy = false;
      localStorage.setItem('cookiesPolicyHasBeenAccepted', true);
    }
  })
});

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(17);

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-09, 13:08:58
 * Author: Sebastian Drzewicki <sebastian.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-22, 12:14:51
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */



// COMPONENT ///////////////////////////////////////////////////////////////////
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OfflineIndicator',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  data: function data() {
    return {
      online: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isOffline'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['toggleOfflineStatus'])),
  mounted: function mounted() {
    var _this = this;

    if (navigator) {
      if (!navigator.onLine) this.toggleOfflineStatus();
    }
    window.addEventListener('online', function () {
      return _this.toggleOfflineStatus();
    });
    window.addEventListener('offline', function () {
      return _this.toggleOfflineStatus();
    });
  }
});

/***/ }),

/***/ 904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sAuth__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routes__ = __webpack_require__(992);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_4__routes__["a" /* default */],
  mode: ''
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('selectCategory', null);
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // verify JWT token
    if (!__WEBPACK_IMPORTED_MODULE_3__services_sAuth__["a" /* default */].verifyToken()) {
      next({ path: '/' });
      __WEBPACK_IMPORTED_MODULE_3__services_sAuth__["a" /* default */].removeToken();
    } else {
      next();
    }
  } else if (__WEBPACK_IMPORTED_MODULE_3__services_sAuth__["a" /* default */].verifyToken()) {
    next({ path: '/my-account' });
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(957);
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-23, 14:43:44
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */



var INITIAL_STATE = {
  authType: 'initial',
  isAuthenticated: false,
  loginCredentialsIncorrect: false,
  loginErrorReason: null,
  loginLoadingActive: false,
  subscriber: {
    number: null,
    code: null,
    type: null,
    id: null,
    account_balance: null,
    individual_account_number: null
  },
  settings: {
    complainsCategories: null
  },
  acl: {
    isMainNumber: true,
    privileges: {}
  }
};

var getters = {
  authType: function authType(state) {
    return state.authType;
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.isAuthenticated;
  },
  loginCredentialsIncorrect: function loginCredentialsIncorrect(state) {
    return state.loginCredentialsIncorrect;
  },
  loginLoadingActive: function loginLoadingActive(state) {
    return state.loginLoadingActive;
  },
  loginErrorReason: function loginErrorReason(state) {
    return state.loginErrorReason;
  },
  subscriber: function subscriber(state) {
    return state.subscriber;
  },
  settings: function settings(state) {
    return state.settings;
  },
  acl: function acl(state) {
    return state.acl;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 907:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sAuth__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_sErrorHandler__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(72);


/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 14:15:02
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 13:59:24
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */






/* harmony default export */ __webpack_exports__["a"] = ({
  checkNumber: function checkNumber(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
    var subscriberNumber = payload.subscriberNumber;

    return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_URL */] + '/authenticate?number=' + subscriberNumber).then(function (response) {
      var authType = response.data.data.action;
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* LOGIN_REQUEST */], { authType: authType, subscriberNumber: subscriberNumber });
    }).catch(function (reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
      if (reject.response.code !== 'ECONNABORTED') {
        var errors = reject.response.data ? reject.response.data.data : '';
        var errorMessage = __WEBPACK_IMPORTED_MODULE_4__services_sErrorHandler__["a" /* default */].createErrorMessage(errors);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* LOGIN_FAIL */], { errorMessage: errorMessage });
      }
    });
  },
  validateSMSCode: function validateSMSCode(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
    var SMSCode = payload.SMSCode;

    var validateSMSRequestType = state.authType === 'registration' ? 'codes?code' : 'passwordChange/checkSms?code';
    return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_URL */] + '/' + validateSMSRequestType + '=' + SMSCode).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* SET_SMS_CODE */], { SMSCode: SMSCode });
      var authType = state.authType === 'registration' ? 'createNewPassword' : 'createNewPasswordForRegisteredUser';
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* LOGIN_REQUEST */], { authType: authType });
    }, function (reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
      if (reject.code !== 'ECONNABORTED') {
        var errors = reject.response.data ? reject.response.data.data : '';
        var errorMessage = __WEBPACK_IMPORTED_MODULE_4__services_sErrorHandler__["a" /* default */].createErrorMessage(errors);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* LOGIN_FAIL */], { errorMessage: errorMessage });
      }
    });
  },
  setPassword: function setPassword(_ref3, payload) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
    var newPassword = payload.newPassword;

    var params = {
      password: newPassword,
      code: state.subscriber.code
    };
    return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* API */].put(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_URL */] + '/authenticate', params).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* CONFIRM_CHANGE_PASSWORD */], { authType: 'initial' });
    }, function (reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
      if (reject.code !== 'ECONNABORTED') {
        var errors = reject.response.data ? reject.response.data.data : '';
        var errorMessage = __WEBPACK_IMPORTED_MODULE_4__services_sErrorHandler__["a" /* default */].createErrorMessage(errors);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* LOGIN_FAIL */], { errorMessage: errorMessage });
      }
    });
  },
  validatePassword: function validatePassword(_ref4, payload) {
    var commit = _ref4.commit,
        state = _ref4.state,
        dispatch = _ref4.dispatch;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
    var password = payload.password;

    var params = {
      password: password,
      number: state.subscriber.number
    };
    return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* API */].post(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_URL */] + '/authenticate', params).then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
      var token = response.data.data.token;

      dispatch('logIn', { token: token });
    }, function (reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
      if (reject.code !== 'ECONNABORTED') {
        // przypadek szczególny - jest to zalogowanie użytkownika co oznacza, że powinniśmy
        // zwrócić tylko jeden powód błędu - "Podane hasło jest nieprawidłowe"
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* LOGIN_FAIL */], { errorMessage: 'Podane hasło jest nieprawidłowe' });
      }
    });
  },
  logIn: function logIn(_ref5, payload) {
    var commit = _ref5.commit,
        state = _ref5.state;
    var token = payload.token;

    __WEBPACK_IMPORTED_MODULE_3__services_sAuth__["a" /* default */].setToken(token);
    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* LOGIN_SUCCESS */]);
  },
  getMe: function getMe(_ref6) {
    var _this = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var subscriber;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_URL */] + '/me');

            case 2:
              subscriber = _context.sent.data.data;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_SUBSCRIBER_MAIN_DATA */], subscriber);
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* SET_SUBSCRIBER_SETTINGS */], subscriber);
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS */], subscriber);
              return _context.abrupt('return', subscriber);

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  logOut: function logOut() {
    return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* API */].delete(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_URL */] + '/authenticate').then(function () {
      __WEBPACK_IMPORTED_MODULE_3__services_sAuth__["a" /* default */].removeToken();
    });
  },
  undoLoginState: function undoLoginState(_ref7, payload) {
    var commit = _ref7.commit;

    var previousState = payload;
    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* UNDO_LOGIN_STATE */], { previousState: previousState });
  },
  setSubscriberMainData: function setSubscriberMainData(_ref8, payload) {
    var commit = _ref8.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_SUBSCRIBER_MAIN_DATA */], payload);
  },
  setSubscriberSettings: function setSubscriberSettings(_ref9, payload) {
    var commit = _ref9.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* SET_SUBSCRIBER_SETTINGS */], payload);
  },
  setSubsriberAclForGroupsOfNumbers: function setSubsriberAclForGroupsOfNumbers(_ref10, payload) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS */], payload);
  },
  confirmChangePassword: function confirmChangePassword(_ref11) {
    var commit = _ref11.commit,
        state = _ref11.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
    var subscriberNumber = state.subscriber.number;
    return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_URL */] + '/passwordChange/sendSms?number=' + subscriberNumber).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* CONFIRM_CHANGE_PASSWORD */], { authType: 'sendSmsAfterPasswordChangeRequest' });
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
    }, function (reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
      if (reject.code !== 'ECONNABORTED') {
        var errors = reject.response.data.data;
        var errorMessage = __WEBPACK_IMPORTED_MODULE_4__services_sErrorHandler__["a" /* default */].createErrorMessage(errors);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* LOGIN_FAIL */], { errorMessage: errorMessage });
      }
    });
  },
  submitSetNewPassword: function submitSetNewPassword(_ref12, payload) {
    var commit = _ref12.commit,
        state = _ref12.state;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
    var newPassword = payload.newPassword;

    var params = {
      password: newPassword,
      code: state.subscriber.code
    };
    return __WEBPACK_IMPORTED_MODULE_2__config__["a" /* API */].post(__WEBPACK_IMPORTED_MODULE_2__config__["b" /* API_URL */] + '/passwordChange', params).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* CONFIRM_CHANGE_PASSWORD */], { authType: 'initial' });
    }, function (reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */]);
      if (reject.code !== 'ECONNABORTED') {
        var errors = reject.response.data.data;
        var errorMessage = __WEBPACK_IMPORTED_MODULE_4__services_sErrorHandler__["a" /* default */].createErrorMessage(errors);
        commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* LOGIN_FAIL */], { errorMessage: errorMessage });
      }
    });
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_polyfils__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_polyfils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utils_polyfils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_toaster__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_toaster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_toaster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_touch__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raven_js_plugins_vue__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_filters__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__App__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__filters__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__node_modules_hammerjs__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__node_modules_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__node_modules_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives__ = __webpack_require__(1008);
// ADD POLYFILS


// EXTERNAL DEPENDENCIES ///////////////////////////////////////////////////////













// INTERNAL DEPENDENCIES ///////////////////////////////////////////////////////




// ADD ALL VUE FILTERS




delete __WEBPACK_IMPORTED_MODULE_17__node_modules_hammerjs___default.a.defaults.cssProps.userSelect;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$EventBus = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]();

// VUE CONFIG //////////////////////////////////////////////////////////////////
Object(__WEBPACK_IMPORTED_MODULE_2_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_touch___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_v_toaster___default.a, { timeout: 5000 });

// VEE VALIDATE ////////////////////////////////////////////////////////////////
var veeConfig = { events: 'blur' };
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["a" /* default */], veeConfig);

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

// ADD STYLE ///////////////////////////////////////////////////////////////////
__webpack_require__(1009);
__webpack_require__(1010);
__webpack_require__(1011);
__webpack_require__(1012);
__webpack_require__(1013);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  components: { App: __WEBPACK_IMPORTED_MODULE_15__App__["a" /* default */] },
  router: __WEBPACK_IMPORTED_MODULE_13__router__["a" /* default */],
  template: '<App />'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('datepicker', __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker___default.a);

// ADD SENTRY /////////////////////////////////////////////////////////////////
/* eslint-disable */
if (true) {
  console.log('==> lajt-online.pl');
  __WEBPACK_IMPORTED_MODULE_10_raven_js___default.a.config('https://ded98f033ecb4374b769b0532985b356@sentry.io/228676').addPlugin(__WEBPACK_IMPORTED_MODULE_11_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]).install();
}

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

/* eslint-disable */

// Array.includes(); - polyfil from MDN => https://developer.mozilla.org/pl/docs/Web/JavaScript/Referencje/Obiekty/Array/includes
if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement /* , fromIndex */) {
    var O = Object(this);
    var len = parseInt(O.length, 0) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1], 0) || 0;
    var k = void 0;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {
        k = 0;
      }
    }
    var currentElement = void 0;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
        // NaN !== NaN
        return true;
      }
      k++;
    }
    return false;
  };
}

/***/ }),

/***/ 956:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 10:55:28
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
// Mapa wszystkich możliwych błędów, które zwróci API w przypadku statusu HTTP 406 (Not Acceptable)

/* eslint-disable key-spacing */
/* harmony default export */ __webpack_exports__["a"] = ({
  // number
  'number|type': 'Przepraszamy. Panel Online nie jest w tym momencie dostępny. Trwa aktualizacja danych [101].',
  'number|length': 'Nieprawidłowa długość numeru - numer powinien mieć 9 cyfr',
  'number|required': 'Nie podano numeru telefonu',
  'number|not_found': 'Przepraszamy. Panel Online nie jest w tym momencie dostępny. Trwa aktualizacja danych [102].',
  'number|blocked': 'Przepraszamy. Panel Online nie jest w tym momencie dostępny. Trwa aktualizacja danych [103].',
  'number|login_register_blocked': 'Przepraszamy. Panel Online nie jest w tym momencie dostępny. Trwa aktualizacja danych [104].',
  // password
  'password|type': '???',
  'password|number': 'Hasło powinno zawierać co najmniej jedną cyfrę',
  'password|letter': 'Hasło powinno zawierać co najmniej jedną dużą literę',
  'password|latin': 'Hasło nie może zawierać polskich znaków',
  'password|length': 'Hasło musi mieć co najmniej 8 znaków',
  'password|required': 'Nie podano hasła',
  'password|whitespace': 'Hasło nie może zawierać "białych znaków" (np. spacja)',
  // sms code
  'code|type': '???',
  'code|length': 'Nieprawidłowa dugość kodu SMS',
  'code|required': 'Nie podano kodu SMS',
  'code|not_found': 'Podany kod jest nieprawidłowy',
  'code|verification': 'Podany kod został już wykorzystany',
  'code|code_expired': 'Ważność kodu SMS wygasła',
  // invoice
  'invoce|not_found': 'Trwa aktualizacja bazy danych. Faktura pojawi się do 24 godz.',
  // complains
  'content|required': 'Treść zgłoszenia nie może być pusta',
  // rodo terms
  'terms|required': 'Nie wszystkie wymagane pola zostały zaznaczone'
});

/***/ }),

/***/ 957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(72);


var _LOGIN_REQUEST$SET_SM;

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 14:15:11
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 13:08:17
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */


/* harmony default export */ __webpack_exports__["a"] = (_LOGIN_REQUEST$SET_SM = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* LOGIN_REQUEST */], function (state, payload) {
  var _state = state;
  _state.authType = payload.authType;
  _state.loginCredentialsIncorrect = false;
  _state.subscriber.number = payload.subscriberNumber || state.subscriber.number;
  _state.loginLoadingActive = !state.loginLoadingActive;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* SET_SMS_CODE */], function (state, payload) {
  var _state = state;
  _state.subscriber.code = payload.SMSCode;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* LOGIN_SUCCESS */], function (state) {
  var _state = state;
  _state.isAuthenticated = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* LOGOUT_SUCCESS */], function (state) {
  var _state = state;
  _state.authType = 'initial';
  _state.isAuthenticated = false;
  _state.loginCredentialsIncorrect = false;
  _state.subscriber = {
    number: null,
    code: null,
    type: null,
    id: null,
    accountBalance: null,
    complains_categories: null
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* LOGIN_FAIL */], function (state, payload) {
  var _state = state;
  _state.loginCredentialsIncorrect = true;
  _state.loginErrorReason = payload.errorMessage;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* TOGGLE_LOGIN_LOADING */], function (state) {
  var _state = state;
  _state.loginLoadingActive = !state.loginLoadingActive;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* UNDO_LOGIN_STATE */], function (state, payload) {
  var _state = state;
  _state.authType = payload.previousState;
  _state.loginCredentialsIncorrect = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SET_SUBSCRIBER_MAIN_DATA */], function (state, payload) {
  var _state = state;
  _state.subscriber = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_SUBSCRIBER_SETTINGS */], function (state, payload) {
  var _state = state;
  _state.settings.complainsCategories = payload.complains_categories;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* SET_SUBSCRIBER_ACL_FOR_GROUPS_OF_NUMBERS */], function (state, payload) {
  var _state = state;
  _state.acl.isMainNumber = payload.is_main_number || true;
  _state.acl.privileges = payload.privileges || {};
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOGIN_REQUEST$SET_SM, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CONFIRM_CHANGE_PASSWORD */], function (state, payload) {
  var _state = state;
  _state.authType = payload.authType;
}), _LOGIN_REQUEST$SET_SM);

/***/ }),

/***/ 958:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(968);
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-10-24, 11:29:27
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:59:58
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */



var INITIAL_STATE = {
  rechargesList: {
    terms: {
      dateStart: null,
      dateEnd: null,
      sort: 'desc',
      sortBy: 'date'
    },
    data: []
  }
};

var getters = {
  rechargesList: function rechargesList(state) {
    return state.rechargesList;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 959:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_decorators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(73);






var _dec, _desc, _value, _obj;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 14:12:43
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 15:00:56
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */





/* harmony default export */ __webpack_exports__["a"] = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6__utils_decorators__["b" /* togglePendingStoreActions */])(), (_obj = {
  setRechargesTerms: function setRechargesTerms(_ref) {
    var dispatch = _ref.dispatch,
        commit = _ref.commit,
        state = _ref.state;
    var newTerms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var terms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.rechargesList.terms, newTerms);
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["b" /* SET_RECHARGES_TERMS */], { terms: terms });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
  },
  getRechargesList: function getRechargesList(_ref2) {
    var _this = this;

    var commit = _ref2.commit,
        state = _ref2.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _state$rechargesList$, dateStart, dateEnd, sort, sortBy, params, rechargesList;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _state$rechargesList$ = state.rechargesList.terms, dateStart = _state$rechargesList$.dateStart, dateEnd = _state$rechargesList$.dateEnd, sort = _state$rechargesList$.sort, sortBy = _state$rechargesList$.sortBy;
              params = {
                from: dateStart,
                to: dateEnd,
                sortby: sortBy,
                sort: sort
              };
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_5__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_5__config__["b" /* API_URL */] + '/recharges', { params: params });

            case 4:
              rechargesList = _context.sent.data.data;

              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["a" /* COMPLETE_RECHARGES_LIST */], { rechargesList: rechargesList });

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
}, (_applyDecoratedDescriptor(_obj, 'getRechargesList', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getRechargesList'), _obj)), _obj));

/***/ }),

/***/ 968:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(73);


var _SET_RECHARGES_TERMS$;

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 14:12:50
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:59:51
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */


/* harmony default export */ __webpack_exports__["a"] = (_SET_RECHARGES_TERMS$ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_RECHARGES_TERMS$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_RECHARGES_TERMS */], function (state, payload) {
  var _state = state;
  _state.rechargesList.terms = payload.terms;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_RECHARGES_TERMS$, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* COMPLETE_RECHARGES_LIST */], function (state, payload) {
  var _state = state;
  _state.rechargesList.data = payload.rechargesList;
}), _SET_RECHARGES_TERMS$);

/***/ }),

/***/ 969:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(971);
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-23, 16:28:53
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-05, 14:57:33
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */




var INITIAL_STATE = {
  billingList: {
    terms: {
      dateStart: null,
      dateEnd: null,
      sort: 'desc',
      sortBy: 'date',
      page: 1
    },
    data: [],
    summary: {},
    count: 0
  }
};

var getters = {
  billingList: function billingList(state) {
    return state.billingList;
  },
  billingListActualPage: function billingListActualPage(state) {
    return state.billingList.terms.page;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 970:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_decorators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mutation_types__ = __webpack_require__(74);






var _dec, _dec2, _desc, _value, _obj;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:53:53
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:15:19
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */





/* harmony default export */ __webpack_exports__["a"] = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_6__utils_decorators__["a" /* handleErrorResponses */])(), (_obj = {
  setBillingTerms: function setBillingTerms(_ref) {
    var commit = _ref.commit,
        state = _ref.state;
    var newTerms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var terms = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, state.billingList.terms, newTerms);
    commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["c" /* SET_BILLING_TERMS */], { terms: terms });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.resolve();
  },
  getBillingList: function getBillingList(_ref2) {
    var _this = this;

    var commit = _ref2.commit,
        state = _ref2.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _state$billingList$te, dateStart, dateEnd, sort, sortBy, page, number, params, _data$data, list, count, summary;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _state$billingList$te = state.billingList.terms, dateStart = _state$billingList$te.dateStart, dateEnd = _state$billingList$te.dateEnd, sort = _state$billingList$te.sort, sortBy = _state$billingList$te.sortBy, page = _state$billingList$te.page;
              number = state.billingList.terms.phoneNumber || 'null';
              params = {
                from: dateStart,
                to: dateEnd,
                sortby: sortBy,
                sort: sort,
                number: number,
                page: page
              };
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_5__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_5__config__["b" /* API_URL */] + '/billing', { params: params });

            case 5:
              _data$data = _context.sent.data.data;
              list = _data$data.list;
              count = _data$data.count;
              summary = _data$data.summary;

              commit(__WEBPACK_IMPORTED_MODULE_7__mutation_types__["b" /* COMPLETE_BILLING_LIST */], { list: list, count: count, summary: summary });

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
}, (_applyDecoratedDescriptor(_obj, 'getBillingList', [_dec, _dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getBillingList'), _obj)), _obj));

/***/ }),

/***/ 971:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(74);


var _SET_BILLING_TERMS$CO;

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:53:59
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:15:40
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */


/* harmony default export */ __webpack_exports__["a"] = (_SET_BILLING_TERMS$CO = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_BILLING_TERMS$CO, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_BILLING_TERMS */], function (state, payload) {
  var _state = state;
  _state.billingList.terms = payload.terms;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_BILLING_TERMS$CO, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* COMPLETE_BILLING_LIST */], function (state, payload) {
  var _state = state;
  _state.billingList.data = payload.list;
  _state.billingList.count = payload.count;
  _state.billingList.summary = payload.summary;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_BILLING_TERMS$CO, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLEAR_BILLING_LIST */], function (state) {
  var _state = state;
  _state.billingList.data = [];
}), _SET_BILLING_TERMS$CO);

/***/ }),

/***/ 972:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(974);
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-21, 09:54:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 14:12:13
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */



var INITIAL_STATE = {
  brandTheme: null,
  brandLogos: {
    main: null,
    panel: null,
    panel_hover: null,
    mobile: null
  },
  brandId: null,
  isError: false
};

var getters = {
  brandTheme: function brandTheme(state) {
    return state.brandTheme;
  },
  brandLogos: function brandLogos(state) {
    return state.brandLogos;
  },
  brandId: function brandId(state) {
    return state.brandId;
  },
  isError: function isError(state) {
    return state.isError;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 973:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_decorators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(75);




var _dec, _desc, _value, _obj;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:56:24
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 14:12:09
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */





/* harmony default export */ __webpack_exports__["a"] = (_dec = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), (_obj = {
  getBrandTheme: function getBrandTheme(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _data$data, theme, logos, is_error, brand_id;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/theme');

            case 2:
              _data$data = _context.sent.data.data;
              theme = _data$data.theme;
              logos = _data$data.logos;
              is_error = _data$data.is_error;
              brand_id = _data$data.brand_id;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* FILL_BRAND_THEME */], { theme: theme, logos: logos, is_error: is_error, brand_id: brand_id });

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
}, (_applyDecoratedDescriptor(_obj, 'getBrandTheme', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getBrandTheme'), _obj)), _obj));

/***/ }),

/***/ 974:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(75);

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:56:28
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 14:12:17
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FILL_BRAND_THEME */], function (state, payload) {
  var _state = state;
  _state.brandTheme = payload.theme;
  _state.brandLogos = payload.logos;
  _state.isError = payload.is_error;
  _state.brandId = payload.brand_id;
}));

/***/ }),

/***/ 975:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(977);
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-26, 10:33:12
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:34:38
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */




var INITIAL_STATE = {
  faqList: []
};

var getters = {
  faqList: function faqList(state) {
    return state.faqList;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 976:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_decorators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(76);




var _dec, _desc, _value, _obj;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-26, 10:33:12
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:43:07
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */






/* harmony default export */ __webpack_exports__["a"] = (_dec = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), (_obj = {
  getFaqList: function getFaqList(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var faqList;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/faq');

            case 2:
              faqList = _context.sent.data.data;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* FILL_FAQ_LIST */], { faqList: faqList });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
}, (_applyDecoratedDescriptor(_obj, 'getFaqList', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getFaqList'), _obj)), _obj));

/***/ }),

/***/ 977:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(76);

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-26, 10:33:12
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 10:36:25
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FILL_FAQ_LIST */], function (state, payload) {
  var _state = state;
  _state.faqList = payload.faqList;
}));

/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(980);
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:05:03
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */



var INITIAL_STATE = {
  pendingStoreActions: [],
  isOffline: false,
  mobileMenuIsVisible: false,
  bannersList: [],
  mainComponentsVisibility: {},
  panelFooterIcons: [],
  rodoTerms: [],
  occasionZoneTilesContents: {},
  occasionZoneFormSettings: {}
};

var getters = {
  pendingStoreActions: function pendingStoreActions(state) {
    return state.pendingStoreActions;
  },
  isOffline: function isOffline(state) {
    return state.isOffline;
  },
  bannersList: function bannersList(state) {
    return state.bannersList;
  },
  mobileMenuIsVisible: function mobileMenuIsVisible(state) {
    return state.mobileMenuIsVisible;
  },
  mainComponentsVisibility: function mainComponentsVisibility(state) {
    return state.mainComponentsVisibility;
  },
  panelFooterIcons: function panelFooterIcons(state) {
    return state.panelFooterIcons;
  },
  rodoTerms: function rodoTerms(state) {
    return state.rodoTerms;
  },
  shouldShowRodoTerms: function shouldShowRodoTerms(state) {
    return state.rodoTerms.length > 0;
  },
  occasionZoneTilesContents: function occasionZoneTilesContents(state) {
    return state.occasionZoneTilesContents;
  },
  occasionZoneFormSettings: function occasionZoneFormSettings(state) {
    return state.occasionZoneFormSettings;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_decorators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(77);




var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _desc, _value, _obj;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:49:48
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:04:20
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */





/* harmony default export */ __webpack_exports__["a"] = (_dec = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec5 = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec6 = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["a" /* handleErrorResponses */])(), _dec7 = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec8 = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), (_obj = {
  toggleOfflineStatus: function toggleOfflineStatus(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* TOGGLE_OFFLINE_STATUS */]);
  },
  getBannerList: function getBannerList(_ref2) {
    var _this = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var banners;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/settings/baners');

            case 2:
              banners = _context.sent.data.data;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* FILL_BANNERS_LIST */], { banners: banners });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  showMobileMenuList: function showMobileMenuList(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if (!state.mobileMenuIsVisible) commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* TOGGLE_MOBILE_MENU */]);
  },
  hideMobileMenuList: function hideMobileMenuList(_ref4) {
    var commit = _ref4.commit,
        state = _ref4.state;

    if (state.mobileMenuIsVisible) commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* TOGGLE_MOBILE_MENU */]);
  },
  getInformationAboutMainComponentsVisibility: function getInformationAboutMainComponentsVisibility(_ref5) {
    var _this2 = this;

    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var components;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/components');

            case 2:
              components = _context2.sent.data.data;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["b" /* FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY */], { components: components });

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getPanelFooterIcons: function getPanelFooterIcons(_ref6) {
    var _this3 = this;

    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var panelFooterIcons;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/footerIcons');

            case 2:
              panelFooterIcons = _context3.sent.data.data;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* FILL_PANEL_FOOTER_ICONS */], { panelFooterIcons: panelFooterIcons });

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getRodoTerms: function getRodoTerms(_ref7) {
    var _this4 = this;

    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var rodoTerms;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/terms/rodo');

            case 2:
              rodoTerms = _context4.sent.data.data;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* FILL_RODO_TERMS */], { rodoTerms: rodoTerms });

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  sendAcceptedTerms: function sendAcceptedTerms(_ref8, selectedTerms) {
    var _this5 = this;

    var commit = _ref8.commit,
        state = _ref8.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var termsToSend;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              termsToSend = state.rodoTerms.map(function (term) {
                return {
                  id: term.id,
                  accepted: selectedTerms.includes(term.id)
                };
              });
              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].put(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/terms/rodo', { terms: termsToSend });

            case 3:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* FILL_RODO_TERMS */], { rodoTerms: [] });

            case 4:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getOccasionZoneTilesContents: function getOccasionZoneTilesContents(_ref9) {
    var _this6 = this;

    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var occasionZoneTilesContents;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/occasionZoneTiles');

            case 2:
              occasionZoneTilesContents = _context6.sent.data.data;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* FILL_OCCASION_ZONE_TILES_CONTENTS */], { occasionZoneTilesContents: occasionZoneTilesContents });

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getOccasionZoneFormSettings: function getOccasionZoneFormSettings(_ref10) {
    var _this7 = this;

    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var occasionZoneFormSettings, groupedSettings, uniqueGroupedSettings;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/occasionZoneFormSettings');

            case 2:
              occasionZoneFormSettings = _context7.sent.data.data;
              groupedSettings = occasionZoneFormSettings.map(function (subject) {
                var subjectsList = [];
                occasionZoneFormSettings.forEach(function (element) {
                  if (element.category_name === subject.category_name) {
                    subjectsList.push({
                      id: element.id,
                      subject: element.name
                    });
                  }
                });
                return {
                  category: subject.category_name,
                  subjects: subjectsList,
                  id: subject.category_id
                };
              });
              uniqueGroupedSettings = {
                complainsCategories: groupedSettings.filter(function (value, index, self) {
                  return index === self.findIndex(function (t) {
                    return t.category === value.category;
                  });
                })
              };

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* FILL_OCCASION_ZONE_FORM_SETTINGS */], { occasionZoneFormSettings: uniqueGroupedSettings });

            case 6:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  }
}, (_applyDecoratedDescriptor(_obj, 'getBannerList', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getBannerList'), _obj), _applyDecoratedDescriptor(_obj, 'getInformationAboutMainComponentsVisibility', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getInformationAboutMainComponentsVisibility'), _obj), _applyDecoratedDescriptor(_obj, 'getPanelFooterIcons', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getPanelFooterIcons'), _obj), _applyDecoratedDescriptor(_obj, 'getRodoTerms', [_dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getRodoTerms'), _obj), _applyDecoratedDescriptor(_obj, 'sendAcceptedTerms', [_dec5, _dec6], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'sendAcceptedTerms'), _obj), _applyDecoratedDescriptor(_obj, 'getOccasionZoneTilesContents', [_dec7], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getOccasionZoneTilesContents'), _obj), _applyDecoratedDescriptor(_obj, 'getOccasionZoneFormSettings', [_dec8], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getOccasionZoneFormSettings'), _obj)), _obj));

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(77);


var _TOGGLE_PENDING_STORE;

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:49:54
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:04:49
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */




/* harmony default export */ __webpack_exports__["a"] = (_TOGGLE_PENDING_STORE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_STORE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["i" /* TOGGLE_PENDING_STORE_ACTIONS */], function (state, payload) {
  var _state = state;
  _state.pendingStoreActions = Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["e" /* hToggleArrayItem */])(_state.pendingStoreActions, payload);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_STORE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* TOGGLE_OFFLINE_STATUS */], function (state) {
  var _state = state;
  _state.isOffline = navigator === undefined ? !state.isOffline : !navigator.onLine;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_STORE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* FILL_BANNERS_LIST */], function (state, payload) {
  var _state = state;
  _state.bannersList = payload.banners;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_STORE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* TOGGLE_MOBILE_MENU */], function (state) {
  var _state = state;
  _state.mobileMenuIsVisible = !_state.mobileMenuIsVisible;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_STORE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY */], function (state, payload) {
  var _state = state;
  _state.mainComponentsVisibility = payload.components;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_STORE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* FILL_PANEL_FOOTER_ICONS */], function (state, payload) {
  var _state = state;
  _state.panelFooterIcons = payload.panelFooterIcons;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_STORE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* FILL_RODO_TERMS */], function (state, payload) {
  var _state = state;
  _state.rodoTerms = payload.rodoTerms;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_STORE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* FILL_OCCASION_ZONE_TILES_CONTENTS */], function (state, payload) {
  var _state = state;
  _state.occasionZoneTilesContents = payload.occasionZoneTilesContents;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_TOGGLE_PENDING_STORE, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* FILL_OCCASION_ZONE_FORM_SETTINGS */], function (state, payload) {
  var _state = state;
  _state.occasionZoneFormSettings = payload.occasionZoneFormSettings;
}), _TOGGLE_PENDING_STORE);

/***/ }),

/***/ 983:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(985);
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:11:33
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-06, 13:10:11
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */




var INITIAL_STATE = {
  payments: {
    list: [],
    count: 0
  },
  invoices: {
    list: [],
    count: 0
  },
  correctionInvoices: {
    list: [],
    count: 0
  },
  paymentsError: null
};

var getters = {
  customerPayments: function customerPayments(state) {
    return state.payments;
  },
  customerInvoices: function customerInvoices(state) {
    return state.invoices;
  },
  customerCorrectionInvoices: function customerCorrectionInvoices(state) {
    return state.correctionInvoices;
  },
  lastInvoice: function lastInvoice(state) {
    return state.invoices.list[0];
  },
  paymentsError: function paymentsError(state) {
    return state.paymentsError;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_decorators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutation_types__ = __webpack_require__(78);





var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _desc, _value, _obj;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:11:33
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 12:23:25
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */






/* harmony default export */ __webpack_exports__["a"] = (_dec = Object(__WEBPACK_IMPORTED_MODULE_5__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_5__utils_decorators__["a" /* handleErrorResponses */])(), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_5__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_5__utils_decorators__["a" /* handleErrorResponses */])(), _dec5 = Object(__WEBPACK_IMPORTED_MODULE_5__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec6 = Object(__WEBPACK_IMPORTED_MODULE_5__utils_decorators__["a" /* handleErrorResponses */])(), _dec7 = Object(__WEBPACK_IMPORTED_MODULE_5__utils_decorators__["b" /* togglePendingStoreActions */])(), (_obj = {
  getCustomerPaymentsData: function getCustomerPaymentsData(_ref) {
    var _this = this;

    var commit = _ref.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _data$data, payments, correction_invoices;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_URL */] + '/payments');

            case 2:
              _data$data = _context.sent.data.data;
              payments = _data$data.payments;
              correction_invoices = _data$data.correction_invoices;

              commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["c" /* FILL_PAYMENTS_DATA */], { payments: payments });
              commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["a" /* FILL_CORRECTION_INVOICES_DATA */], { correction_invoices: correction_invoices });

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getCustomerInvoicesData: function getCustomerInvoicesData(_ref2) {
    var _this2 = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var _data$data2, list, count;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_URL */] + '/invoices');

            case 2:
              _data$data2 = _context2.sent.data.data;
              list = _data$data2.list;
              count = _data$data2.count;

              commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["b" /* FILL_INVOICES_DATA */], { list: list, count: count });

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  downloadInvoiceFile: function downloadInvoiceFile(_ref3) {
    var _this3 = this;

    var commit = _ref3.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].post(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_URL */] + '/invoice/checkIsExist', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params));

            case 2:
              window.open(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_URL */] + '/invoice/download?year=' + params.year + '&month=' + params.month);

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  genratePaymentToken: function genratePaymentToken(_ref4) {
    var _this4 = this;

    var commit = _ref4.commit;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var url, errorData;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].post(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_URL */] + '/payments/token/generate', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params));

            case 3:
              url = _context4.sent.data.data.url;

              commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["d" /* SET_PAYMENTS_ERROR */], { paymentsError: null });
              window.location.href = url;
              _context4.next = 12;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4['catch'](0);
              errorData = _context4.t0.response && _context4.t0.response.data ? _context4.t0.response.data.data : {};

              commit(__WEBPACK_IMPORTED_MODULE_6__mutation_types__["d" /* SET_PAYMENTS_ERROR */], {
                paymentsError: {
                  message: errorData.message || 'Wystąpił nieoczekiwany błąd',
                  dateFrom: errorData.date_from || null,
                  dateTo: errorData.date_to || null
                }
              });

            case 12:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[0, 8]]);
    }))();
  }
}, (_applyDecoratedDescriptor(_obj, 'getCustomerPaymentsData', [_dec, _dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getCustomerPaymentsData'), _obj), _applyDecoratedDescriptor(_obj, 'getCustomerInvoicesData', [_dec3, _dec4], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'getCustomerInvoicesData'), _obj), _applyDecoratedDescriptor(_obj, 'downloadInvoiceFile', [_dec5, _dec6], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'downloadInvoiceFile'), _obj), _applyDecoratedDescriptor(_obj, 'genratePaymentToken', [_dec7], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'genratePaymentToken'), _obj)), _obj));

/***/ }),

/***/ 985:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(78);


var _FILL_PAYMENTS_DATA$F;

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:11:33
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-01, 11:54:46
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */



/* harmony default export */ __webpack_exports__["a"] = (_FILL_PAYMENTS_DATA$F = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_PAYMENTS_DATA$F, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* FILL_PAYMENTS_DATA */], function (state, payload) {
  var _state = state;
  _state.payments.list = payload.payments.list;
  _state.payments.count = payload.payments.count;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_PAYMENTS_DATA$F, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FILL_CORRECTION_INVOICES_DATA */], function (state, payload) {
  var _state = state;
  _state.correctionInvoices.list = payload.correction_invoices.list;
  _state.correctionInvoices.count = payload.correction_invoices.count;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_PAYMENTS_DATA$F, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* FILL_INVOICES_DATA */], function (state, payload) {
  var _state = state;
  _state.invoices.list = payload.list;
  _state.invoices.count = payload.count;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_FILL_PAYMENTS_DATA$F, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SET_PAYMENTS_ERROR */], function (state, payload) {
  var _state = state;
  _state.paymentsError = payload.paymentsError;
}), _FILL_PAYMENTS_DATA$F);

/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(988);
/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-10, 12:18:00
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-10, 12:53:03
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */




var INITIAL_STATE = {
  complainsFormHasBeenSent: false
};

var getters = {
  complainsFormHasBeenSent: function complainsFormHasBeenSent(state) {
    return state.complainsFormHasBeenSent;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 987:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_decorators__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(79);




var _dec, _dec2, _desc, _value, _obj;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-10, 12:18:00
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-10, 12:49:49
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */






/* harmony default export */ __webpack_exports__["a"] = (_dec = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["b" /* togglePendingStoreActions */])(), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_4__utils_decorators__["a" /* handleErrorResponses */])(), (_obj = {
  sendComplainsForm: function sendComplainsForm(_ref, data) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_3__config__["a" /* API */].post(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* API_URL */] + '/mails', data);

            case 2:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* TOGGLE_FORM_SENDING_STATUS */]);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  resetComplainsForm: function resetComplainsForm(_ref2) {
    var commit = _ref2.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["a" /* TOGGLE_FORM_SENDING_STATUS */]);
  }
}, (_applyDecoratedDescriptor(_obj, 'sendComplainsForm', [_dec, _dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_obj, 'sendComplainsForm'), _obj)), _obj));

/***/ }),

/***/ 988:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(79);

/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-10, 12:18:00
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-10, 12:37:54
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* TOGGLE_FORM_SENDING_STATUS */], function (state) {
  var _state = state;
  _state.complainsFormHasBeenSent = !state.complainsFormHasBeenSent;
}));

/***/ }),

/***/ 989:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(991);
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-23, 16:28:53
 * Author: Michał Rejman <michal.rejman@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-05, 14:57:33
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */




var INITIAL_STATE = {
  servicesList: [],
  categoriesList: [],
  servicesBanners: [],
  hasServiceStatusBeenChange: false,
  responseCode: 200,
  servicesListLoading: false,
  changeStatusLoading: false,
  packageUsage: {},
  getUsageLoading: false,
  confirmationRequired: false,
  smsCode: '',
  enabled: false,
  incorrect_code: false,
  selectedCategory: null,
  activationFailed: false
};

var getters = {
  servicesList: function servicesList(state) {
    return state.servicesList;
  },
  categoriesList: function categoriesList(state) {
    return state.categoriesList;
  },
  servicesBanners: function servicesBanners(state) {
    return state.servicesBanners;
  },
  hasServiceStatusBeenChange: function hasServiceStatusBeenChange(state) {
    return state.hasServiceStatusBeenChange;
  },
  responseCode: function responseCode(state) {
    return state.responseCode;
  },
  servicesListLoading: function servicesListLoading(state) {
    return state.servicesListLoading;
  },
  changeStatusLoading: function changeStatusLoading(state) {
    return state.changeStatusLoading;
  },
  packageUsage: function packageUsage(state) {
    return state.packageUsage;
  },
  getUsageLoading: function getUsageLoading(state) {
    return state.getUsageLoading;
  },
  confirmationRequired: function confirmationRequired(state) {
    return state.confirmationRequired;
  },
  smsCode: function smsCode(state) {
    return state.smsCode;
  },
  enabled: function enabled(state) {
    return state.enabled;
  },
  incorrect_code: function incorrect_code(state) {
    return state.incorrect_code;
  },
  selectedCategory: function selectedCategory(state) {
    return state.selectedCategory;
  },
  activationFailed: function activationFailed(state) {
    return state.activationFailed;
  }
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
var Module = {
  state: INITIAL_STATE,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  getters: getters
};

/* harmony default export */ __webpack_exports__["a"] = (Module);

/***/ }),

/***/ 990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutation_types__ = __webpack_require__(80);




/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:53:53
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:15:19
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */




/* harmony default export */ __webpack_exports__["a"] = ({
  getCachedQuery: function getCachedQuery(_ref, url) {
    var commit = _ref.commit;

    if (window.promises === undefined) {
      window.promises = {};
    }
    if (window.promises[url] === undefined) {
      window.promises[url] = __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].get(url);
      var deletePromise = function deletePromise() {
        if (window.promises !== undefined) {
          window.promises[url] = undefined;
        }
      };
      window.promises[url].catch(deletePromise).then(function () {
        setTimeout(deletePromise, 120000);
      });
      return window.promises[url];
    }
    return window.promises[url];
  },
  getServicesList: function getServicesList(_ref2) {
    var _this = this;

    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var status, servicesCallback, result, list, categories, banners;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              status = 200;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_RESPONSE_CODE */], { status: status });
              _context.prev = 2;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* TOOGLE_SERVICES_LIST_LOADING */]);

              servicesCallback = _this._actions.getCachedQuery[0](__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_URL */] + '/services');
              _context.next = 7;
              return servicesCallback;

            case 7:
              result = _context.sent;
              list = result.data.services;
              categories = result.data.categories;
              banners = result.data.banners;


              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["f" /* COMPLETE_LIST */], { list: list });
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["e" /* COMPLETE_CATEGORIES_LIST */], { categories: categories });
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["d" /* COMPLETE_BANNERS_LIST */], { banners: banners });

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_RESPONSE_CODE */], { status: status });
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](2);

              status = 500;
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_RESPONSE_CODE */], { status: status });

            case 21:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["n" /* TOOGLE_SERVICES_LIST_LOADING */]);
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["c" /* CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED */]);

            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[2, 17]]);
    }))();
  },
  changeStatus: function changeStatus(_ref3, data) {
    var _this2 = this;

    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var result, status, enabled, incorrectCode, success, _status;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              result = null;
              _context2.prev = 1;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* TOOGLE_CHANGE_STATUS_LOADING */]);
              window.promises = undefined;
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].patch(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_URL */] + '/service/changeStatus', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, data));

            case 6:
              result = _context2.sent;
              status = result.status;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_RESPONSE_CODE */], { status: status });
              if (result.data.sms_confirmation_required) {
                commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["j" /* SET_SERVICE_STATUS_CONFIRMATION_REQUIRED */]);
              } else {
                enabled = result.data.enabled;
                incorrectCode = result.data.incorrect_code;
                success = result.data.message === 'success';

                commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["k" /* TOGGLE_SERVICE_STATUS_CHANGE_RESULT */], { enabled: enabled, incorrectCode: incorrectCode, success: success });
                if (!incorrectCode) {
                  dispatch('getServicesList');
                }
              }
              _context2.next = 16;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](1);
              _status = 500;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_RESPONSE_CODE */], { status: _status });

            case 16:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["l" /* TOOGLE_CHANGE_STATUS_LOADING */]);
              return _context2.abrupt('return', result);

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 12]]);
    }))();
  },
  getPackageUsage: function getPackageUsage(_ref4, params) {
    var _this3 = this;

    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var result, packageUsage, results, status, _status2;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              result = null;
              packageUsage = false;
              _context3.prev = 2;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* TOOGLE_GET_USAGE_LOADING */]);

              if (!(params instanceof Array)) {
                _context3.next = 12;
                break;
              }

              _context3.next = 7;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(params.map(function (param) {
                return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_URL */] + '/package/usage', { params: param });
              }));

            case 7:
              results = _context3.sent;

              packageUsage = results.map(function (aresult) {
                return aresult.data.data;
              });
              result = results[0];
              _context3.next = 16;
              break;

            case 12:
              _context3.next = 14;
              return __WEBPACK_IMPORTED_MODULE_4__config__["a" /* API */].get(__WEBPACK_IMPORTED_MODULE_4__config__["b" /* API_URL */] + '/package/usage', { params: params });

            case 14:
              result = _context3.sent;

              packageUsage = result.data.data;

            case 16:
              status = result.status;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_RESPONSE_CODE */], { status: status });
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* COMPLETE_PACKAGE_USAGE */], { packageUsage: packageUsage });
              _context3.next = 25;
              break;

            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3['catch'](2);
              _status2 = _context3.t0.response.status;

              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["h" /* SET_RESPONSE_CODE */], { status: _status2 });

            case 25:
              commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["m" /* TOOGLE_GET_USAGE_LOADING */]);
              return _context3.abrupt('return', packageUsage);

            case 27:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[2, 21]]);
    }))();
  },
  clearPackageUsage: function clearPackageUsage(_ref5) {
    var commit = _ref5.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["g" /* COMPLETE_PACKAGE_USAGE */], { packageUsage: [] });
  },
  selectCategory: function selectCategory(_ref6, category) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutation_types__["i" /* SET_SELECTED_CATEGORY */], category);
  }
});

/***/ }),

/***/ 991:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(80);


var _COMPLETE_LIST$COMPLE;

/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:53:59
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:15:40
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */


/* harmony default export */ __webpack_exports__["a"] = (_COMPLETE_LIST$COMPLE = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* COMPLETE_LIST */], function (state, payload) {
  var _state = state;
  _state.servicesList = payload.list;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* COMPLETE_CATEGORIES_LIST */], function (state, payload) {
  var _state = state;
  _state.categoriesList = payload.categories;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* COMPLETE_BANNERS_LIST */], function (state, payload) {
  var _state = state;
  _state.servicesBanners = payload.banners;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* COMPLETE_PACKAGE_USAGE */], function (state, payload) {
  var _state = state;
  _state.packageUsage = payload.packageUsage;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["k" /* TOGGLE_SERVICE_STATUS_CHANGE_RESULT */], function (state, payload) {
  var _state = state;
  if (payload.enabled !== false) {
    _state.hasServiceStatusBeenChange = !state.hasServiceStatusBeenChange;
  }
  if (payload.success === false) {
    _state.activationFailed = true;
  }
  _state.enabled = payload.enabled;
  _state.incorrect_code = payload.incorrectCode;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* CLEAR_SERVICE_STATUS_CHANGE_RESULT */], function (state) {
  var _state = state;
  _state.hasServiceStatusBeenChange = false;
  _state.activationFailed = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* SET_RESPONSE_CODE */], function (state, payload) {
  var _state = state;
  _state.responseCode = payload.status;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* CLEAR_RESPONSE_CODE */], function (state) {
  var _state = state;
  _state.responseCode = '200';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["n" /* TOOGLE_SERVICES_LIST_LOADING */], function (state) {
  var _state = state;
  _state.servicesListLoading = !_state.servicesListLoading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["l" /* TOOGLE_CHANGE_STATUS_LOADING */], function (state) {
  var _state = state;
  _state.changeStatusLoading = !_state.changeStatusLoading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["m" /* TOOGLE_GET_USAGE_LOADING */], function (state) {
  var _state = state;
  _state.getUsageLoading = !_state.getUsageLoading;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["j" /* SET_SERVICE_STATUS_CONFIRMATION_REQUIRED */], function (state) {
  var _state = state;
  _state.confirmationRequired = true;
  _state.enabled = false;
  _state.incorrect_code = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* CLEAR_SERVICE_STATUS_CONFIRMATION_REQUIRED */], function (state) {
  var _state = state;
  _state.confirmationRequired = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_COMPLETE_LIST$COMPLE, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["i" /* SET_SELECTED_CATEGORY */], function (state, payload) {
  var _state = state;
  _state.selectedCategory = payload;
}), _COMPLETE_LIST$COMPLE);

/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 10:20:41
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-01, 14:30:41
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
/* eslint import/no-unresolved: off */

var routes = [{
  path: '/',
  name: 'Login',
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1036));
  }
},
// require authenticate
{
  path: '/',
  component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1037));
  },
  meta: { requiresAuth: true },
  children: [{
    path: '/my-account',
    name: 'MyAccount',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1038));
    }
  }, {
    path: '/paymentsandinvoices',
    name: 'PaymentsAndInvoices',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1039));
    }
  }, {
    path: '/recharges',
    name: 'Recharges',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1040));
    }
  }, {
    path: '/billing',
    name: 'Billing',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1041));
    }
  }, {
    path: '/complains',
    name: 'Complains',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1042));
    },
    props: true
  }, {
    path: '/services',
    name: 'Services',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1043));
    },
    props: true
  }, {
    path: '/occasionZone',
    name: 'OccasionZone',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1044));
    }
  }, {
    path: '/help',
    name: 'Help',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1045));
    }
  }]
},
// catch all redirect
{ path: '*', redirect: '/my-account' }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f565f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1005);
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f565f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89d496d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(998);
function injectStyle (ssrContext) {
  __webpack_require__(997)
}
var normalizeComponent = __webpack_require__(20)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89d496d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 997:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 998:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOffline)?_c('div',{staticClass:"offline-indicator",attrs:{"id":"js-test__offline-indicator"}},[_c('div',{staticClass:"offline-indicator__user-inform animated fadeInUp"},[_vm._v("\n        Wygląda na to, że jesteś offline :(\n    ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 999:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644a0c02_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1001);
function injectStyle (ssrContext) {
  __webpack_require__(1000)
}
var normalizeComponent = __webpack_require__(20)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_644a0c02_hasScoped_false_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},[91]);


// WEBPACK FOOTER //
// static/js/app.912d43563bbc91c418fa.js